/* Plakton South Africa. Maps for Find in store and the contact page.
   Needs leaflet.js loaded first (both are deferred, so order holds). */
(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- pins */
  function pin(colour, big) {
    var w = big ? 34 : 28, h = big ? 44 : 36;
    return window.L.divIcon({
      className: 'map-pin' + (big ? ' map-pin--active' : ''),
      iconSize: [w, h],
      iconAnchor: [w / 2, h],
      popupAnchor: [0, -h + 4],
      html: '<svg width="' + w + '" height="' + h + '" viewBox="0 0 28 36" aria-hidden="true">' +
        '<path d="M14 35s11-11.2 11-21A11 11 0 003 14c0 9.8 11 21 11 21z" fill="' + colour + '" stroke="#fff" stroke-width="1.5"/>' +
        '<circle cx="14" cy="14" r="4.2" fill="#fff"/></svg>'
    });
  }
  function youIcon() {
    return window.L.divIcon({ className: 'map-you', iconSize: [18, 18], iconAnchor: [9, 9], html: '<span></span>' });
  }

  /* -------------------------------------------------------- base map */
  function baseMap(el) {
    var c = (el.getAttribute('data-center') || '-30.5,24.5').split(',').map(parseFloat);
    var map = window.L.map(el, {
      center: c,
      zoom: parseInt(el.getAttribute('data-zoom'), 10) || 5,
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true
    });
    window.L.tileLayer(el.getAttribute('data-tiles') || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: el.getAttribute('data-attribution') || '&copy; OpenStreetMap contributors'
    }).addTo(map);
    map.attributionControl.setPrefix('<a href="https://leafletjs.com" target="_blank" rel="noopener">Leaflet</a>');
    // Wheel zoom only once someone has clicked into the map, so scrolling the
    // page past it never gets trapped.
    map.on('click focus', function () { map.scrollWheelZoom.enable(); });
    map.on('mouseout blur', function () { map.scrollWheelZoom.disable(); });
    if (window.ResizeObserver) new ResizeObserver(function () { map.invalidateSize(); }).observe(el);
    return map;
  }

  function distanceKm(a, b) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (b[0] - a[0]) * toRad, dLng = (b[1] - a[1]) * toRad;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a[0] * toRad) * Math.cos(b[0] * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }
  function formatKm(km) { return km < 10 ? km.toFixed(1) + ' km' : Math.round(km) + ' km'; }

  /* ---------------------------------------------------- store locator */
  function Locator(root) {
    var mapEl = qs('[data-map]', root);
    var list = qs('[data-locator-list]', root);
    var status = qs('[data-locator-status]', root);
    var empty = qs('[data-locator-empty]', root);
    var resetBtn = qs('[data-locator-reset]', root);
    var form = qs('[data-locator-search]', root);
    var input = form ? qs('input', form) : null;
    var geoBtn = qs('[data-locator-geo]', root);
    var useGeocoder = root.getAttribute('data-geocoder') !== 'false';
    var pinColour = mapEl.getAttribute('data-pin') || '#141310';
    var pinActive = mapEl.getAttribute('data-pin-active') || '#a8794f';

    var map = baseMap(mapEl);
    var youMarker = null;
    var origin = null;
    var province = '';
    var textFilter = '';
    var activeId = null;

    var stores = qsa('[data-store]', list).map(function (li, i) {
      var lat = parseFloat(li.getAttribute('data-lat'));
      var lng = parseFloat(li.getAttribute('data-lng'));
      var s = {
        li: li,
        id: li.getAttribute('data-store-id'),
        index: i,
        province: li.getAttribute('data-province') || '',
        search: li.getAttribute('data-search') || '',
        latlng: isFinite(lat) && isFinite(lng) ? [lat, lng] : null,
        marker: null,
        km: null
      };
      if (s.latlng) {
        var name = qs('.store__focus', li).textContent.trim();
        var addr = qs('.store__address', li).innerHTML;
        var dir = qs('.store__link--primary', li);
        s.marker = window.L.marker(s.latlng, { icon: pin(pinColour), title: name, keyboard: true, riseOnHover: true })
          .addTo(map)
          .bindPopup(
            '<div class="map-popup"><strong>' + escapeHtml(name) + '</strong><address>' + addr + '</address>' +
            (dir ? '<a href="' + escapeHtml(dir.href) + '" target="_blank" rel="noopener">Directions</a>' : '') + '</div>',
            { closeButton: true, autoPanPadding: [24, 24] }
          );
        s.marker.on('click', function () { select(s, { fromMap: true }); });
      }
      return s;
    });

    function visible() {
      return stores.filter(function (s) {
        if (province && s.province !== province) return false;
        if (textFilter && s.search.indexOf(textFilter) === -1) return false;
        return true;
      });
    }

    function select(s, opts) {
      opts = opts || {};
      activeId = s.id;
      stores.forEach(function (o) {
        var on = o === s;
        o.li.classList.toggle('is-active', on);
        if (o.marker) { o.marker.setIcon(pin(on ? pinActive : pinColour, on)); o.marker.setZIndexOffset(on ? 1000 : 0); }
      });
      if (s.marker) {
        if (!opts.fromMap) {
          map.flyTo(s.latlng, Math.max(map.getZoom(), 14), { duration: reduced ? 0 : 0.8 });
          map.once('moveend', function () { s.marker.openPopup(); });
        }
      }
      if (opts.fromMap) {
        // Keep the list item in view inside the list, without scrolling the page on desktop.
        var top = s.li.offsetTop - list.offsetTop;
        if (list.scrollHeight > list.clientHeight) list.scrollTo({ top: top - 8, behavior: reduced ? 'auto' : 'smooth' });
        else if (window.innerWidth < 990) s.li.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
      }
    }

    function render(fit) {
      var shown = visible();
      if (origin) {
        stores.forEach(function (s) { s.km = s.latlng ? distanceKm(origin, s.latlng) : null; });
        shown.sort(function (a, b) {
          if (a.km == null) return 1;
          if (b.km == null) return -1;
          return a.km - b.km;
        });
      } else {
        stores.forEach(function (s) { s.km = null; });
        shown.sort(function (a, b) { return a.index - b.index; });
      }

      stores.forEach(function (s) {
        var on = shown.indexOf(s) !== -1;
        s.li.hidden = !on;
        if (s.marker) {
          if (on && !map.hasLayer(s.marker)) s.marker.addTo(map);
          if (!on && map.hasLayer(s.marker)) map.removeLayer(s.marker);
        }
        var d = qs('[data-store-distance]', s.li);
        if (d) { d.hidden = s.km == null; d.textContent = s.km == null ? '' : formatKm(s.km); }
      });
      shown.forEach(function (s) { list.appendChild(s.li); });

      if (empty) empty.hidden = shown.length > 0;
      if (resetBtn) resetBtn.hidden = !(origin || textFilter || province);

      if (fit !== false) fitTo(shown);
      return shown;
    }

    function fitTo(shown) {
      var pts = shown.filter(function (s) { return s.latlng; }).map(function (s) { return s.latlng; });
      if (origin) {
        // Show where they are plus the nearest few stores.
        pts = [origin].concat(pts.slice(0, 3));
      }
      if (!pts.length) return;
      if (pts.length === 1) { map.setView(pts[0], 13, { animate: !reduced }); return; }
      map.fitBounds(window.L.latLngBounds(pts), { padding: [48, 48], maxZoom: 14, animate: !reduced });
    }

    function setStatus(text) { if (status) status.textContent = text; }
    function countText(n) { return n + (n === 1 ? ' store' : ' stores'); }

    function setOrigin(latlng, label) {
      origin = latlng;
      if (youMarker) map.removeLayer(youMarker);
      youMarker = window.L.marker(latlng, { icon: youIcon(), interactive: false, keyboard: false }).addTo(map);
      var shown = render();
      var nearest = shown.filter(function (s) { return s.km != null; })[0];
      if (nearest) {
        setStatus(countText(shown.length) + ', nearest to ' + label + ' first. Closest is ' + formatKm(nearest.km) + ' away.');
      } else {
        setStatus(countText(shown.length) + ' sorted by distance from ' + label + '.');
      }
    }

    function reset() {
      origin = null; textFilter = ''; province = '';
      if (youMarker) { map.removeLayer(youMarker); youMarker = null; }
      if (input) input.value = '';
      qsa('button[data-province]', root).forEach(function (b) {
        var on = b.getAttribute('data-province') === '';
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on));
      });
      map.closePopup();
      var shown = render();
      setStatus(countText(shown.length));
    }

    // List clicks
    list.addEventListener('click', function (e) {
      var f = e.target.closest('[data-store-focus]');
      if (!f) return;
      var li = f.closest('[data-store]');
      var s = stores.filter(function (x) { return x.li === li; })[0];
      if (s) {
        select(s);
        if (window.innerWidth < 990) mapEl.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      }
    });

    // Province chips
    qsa('button[data-province]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        province = b.getAttribute('data-province');
        qsa('button[data-province]', root).forEach(function (o) {
          var on = o === b;
          o.classList.toggle('is-active', on); o.setAttribute('aria-pressed', String(on));
        });
        var shown = render();
        setStatus(countText(shown.length) + (province ? ' in ' + province : ''));
      });
    });

    // Search: a store name or town on the list filters directly. Anything else
    // is looked up as a place and the list is sorted by distance from it.
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = (input.value || '').trim();
        if (!q) { reset(); return; }
        var needle = q.toLowerCase();
        var local = stores.filter(function (s) { return s.search.indexOf(needle) !== -1; });
        if (local.length) {
          origin = null;
          if (youMarker) { map.removeLayer(youMarker); youMarker = null; }
          textFilter = needle;
          var shown = render();
          setStatus(countText(shown.length) + ' matching "' + q + '"');
          return;
        }
        textFilter = '';
        if (!useGeocoder) {
          render();
          setStatus('No stores match "' + q + '". Showing all stores.');
          return;
        }
        var btn = qs('[type="submit"]', form);
        if (btn) btn.classList.add('loading');
        setStatus('Looking up ' + q);
        fetch('https://nominatim.openstreetmap.org/search?format=jsonv2&countrycodes=za&limit=1&accept-language=en&q=' + encodeURIComponent(q))
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (!res || !res.length) {
              render();
              setStatus('We could not find "' + q + '". Try a suburb, town or postcode.');
              return;
            }
            setOrigin([parseFloat(res[0].lat), parseFloat(res[0].lon)], q);
          })
          .catch(function () {
            render();
            setStatus('Search is unavailable right now. Every store is listed below.');
          })
          .finally(function () { if (btn) btn.classList.remove('loading'); });
      });
    }

    // Near me
    if (geoBtn) {
      if (!('geolocation' in navigator)) geoBtn.hidden = true;
      geoBtn.addEventListener('click', function () {
        geoBtn.classList.add('loading');
        setStatus('Finding your location');
        navigator.geolocation.getCurrentPosition(function (pos) {
          geoBtn.classList.remove('loading');
          textFilter = '';
          if (input) input.value = '';
          setOrigin([pos.coords.latitude, pos.coords.longitude], 'you');
        }, function (err) {
          geoBtn.classList.remove('loading');
          setStatus(err && err.code === 1
            ? 'Location is switched off for this site. Search by suburb or postcode instead.'
            : 'We could not get your location. Search by suburb or postcode instead.');
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
      });
    }

    if (resetBtn) resetBtn.addEventListener('click', reset);

    var initial = render();
    setStatus(countText(initial.length));
  }

  /* --------------------------------------------------- single location */
  function Single(el) {
    var map = baseMap(el);
    var lat = parseFloat(el.getAttribute('data-lat'));
    var lng = parseFloat(el.getAttribute('data-lng'));
    if (!isFinite(lat) || !isFinite(lng)) return;
    var popup = qs('template', el.parentNode);
    var m = window.L.marker([lat, lng], { icon: pin(el.getAttribute('data-pin-active') || '#a8794f', true), title: el.getAttribute('data-label') || '' }).addTo(map);
    if (popup) m.bindPopup('<div class="map-popup">' + popup.innerHTML + '</div>');
    map.setView([lat, lng], parseInt(el.getAttribute('data-zoom'), 10) || 15);
  }

  /* -------------------------------------------------------------- boot */
  // Maps only start once they are about to scroll into view, so the tiles are
  // never downloaded for a visitor who never gets that far.
  function whenNear(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '300px' });
    io.observe(el);
  }

  function boot() {
    if (!window.L) return;
    qsa('[data-locator]').forEach(function (root) {
      if (root.__map) return; root.__map = true;
      var el = qs('[data-map]', root);
      if (el) whenNear(el, function () { Locator(root); });
    });
    qsa('[data-map][data-single]').forEach(function (el) {
      if (el.__map) return; el.__map = true;
      whenNear(el, function () { Single(el); });
    });
  }
  boot();
  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
